// Print Mixin - Makes printing easy from any component
import Vue from "vue";
import {
  PrintInvoice,
  PrintJobOrder,
  PrintDeliveryReceipt,
  PrintReturnedItem,
} from "@/components/Print";

export default {
  methods: {
    /**
     * Print an invoice
     * @param {Object} invoice - Invoice object with customer and invoice_items
     * @param {Boolean} displayPrice - Whether to show prices (default: true)
     */
    async printInvoice(invoice, displayPrice = true) {
      const PrintComponent = Vue.extend(PrintInvoice);
      const instance = new PrintComponent({
        store: this.$store,
        propsData: {
          invoice,
          displayPrice,
        },
      });
      instance.$mount();
      document.body.appendChild(instance.$el);

      // Clean up after printing
      setTimeout(() => {
        document.body.removeChild(instance.$el);
        instance.$destroy();
      }, 1000);
    },

    /**
     * Print a job order slip
     * @param {Object} unit - Unit object with customer and problems
     */
    async printJobOrder(unit) {
      const PrintComponent = Vue.extend(PrintJobOrder);
      const instance = new PrintComponent({
        store: this.$store,
        propsData: { unit },
      });
      instance.$mount();
      document.body.appendChild(instance.$el);

      setTimeout(() => {
        document.body.removeChild(instance.$el);
        instance.$destroy();
      }, 1000);
    },

    /**
     * Print a delivery/warranty receipt
     * @param {Object} invoice - Invoice object
     * @param {String} printType - 'mixed' for warranty info or 'quantity' for quantities
     * @param {String} remarks - Optional remarks
     */
    async printDeliveryReceipt(invoice, printType = "mixed", remarks = "") {
      const PrintComponent = Vue.extend(PrintDeliveryReceipt);
      const instance = new PrintComponent({
        store: this.$store,
        propsData: { invoice, printType, remarks },
      });
      instance.$mount();
      document.body.appendChild(instance.$el);

      setTimeout(() => {
        document.body.removeChild(instance.$el);
        instance.$destroy();
      }, 1000);
    },

    /**
     * Print a returned item / RMA form
     * @param {Object} item - Returned item object
     */
    async printReturnedItem(item) {
      const PrintComponent = Vue.extend(PrintReturnedItem);
      const instance = new PrintComponent({
        store: this.$store,
        propsData: { item },
      });
      instance.$mount();
      document.body.appendChild(instance.$el);

      setTimeout(() => {
        document.body.removeChild(instance.$el);
        instance.$destroy();
      }, 1000);
    },

    /**
     * Generic print method - prints raw HTML with dot matrix optimization
     * @param {String} html - HTML content to print
     */
    // eslint-disable-next-line no-unused-vars
    async printGeneric(html) {
      await this.$htmlToPaper("genericPrint", {
        styles: [
          "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css",
        ],
      });
    },
  },
};
